var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.width,"height":_vm.height,"viewBox":"0 0 22 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M16.833 9.62565L10.9994 15.4593L5.16573 9.62565M10.9993 15.1257V3.20898M3.66602 18.7923H18.3327","stroke":"#7B7E8C","stroke-width":"1.5","stroke-linecap":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }